import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  NAME: (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("GET_PRODUCTOS_BY_ATTRS", newActions, newReducers);

const getProductosByAttrs = (page, limit, tipos) => {
  const data ={
    page,
    limit,
    tipos
  }
  let url = `${baseUrl}/getProductosByAttrs`;
  return createThunk(axios, "post", duck.actions, url, data);
};


const duckAddContenido = createDuck("ADD_CONTENIDO", newActions, newReducers);

const addContenidoThunk = (data) => {
  let url = `${baseUrl}/producto`;
  return createThunk(axios, "post", duckAddContenido.actions, url, data);
};

const duckAddReceta = createDuck("ADD_RECETA", newActions, newReducers);

const addRecetaThunk = (data) => {
  let url = `${baseUrl}/producto`;
  return createThunk(axios, "post", duckAddReceta.actions, url, data);
};

const duckDeleteContenido = createDuck('DUCK_DELETE_CONTENIDO', newActions, newReducers);

const deleteContenidoThunk = (id) => {
  const data = {
    id,
  };
  const url = `${baseUrl}/deleteContenido`;
  return createThunk(axios, 'post', duckDeleteContenido.actions, url, data);
};

const duckDeleteReceta = createDuck('DUCK_DELETE_RECETA', newActions, newReducers);

const deleteRecetaThunk = (id) => {
  const data = {
    id,
  };
  const url = `${baseUrl}/deleteContenido`;
  return createThunk(axios, 'post', duckDeleteReceta.actions, url, data);
};

export default {
  duck,
  getProductosByAttrs,
  duckAddContenido,
  addContenidoThunk,
  duckAddReceta,
  addRecetaThunk,
  duckDeleteContenido,
  deleteContenidoThunk,
  duckDeleteReceta,
  deleteRecetaThunk,
};
